export const TIPOS_QR = {
  GENERAL: "GENERAL",
  TIENDA: "TIENDA",
};
